import { AUTHORIZATION_HEADER } from '../../../../../src/authorization';
import { send } from '../../../../../src/network';
import { type TagGroupDetail } from '../../../../../src/types/TagGroupDetail';
import { type TagList } from '../../../../../src/types/TagList';
export { type TagList as Tag, type TagGroupDetail as TagGroupResponse };

export async function getTagGroup(tagGroupId: number) {
  return send<TagGroupDetail>({
    path: `/api/v2/tag_groups/${tagGroupId}`,
    method: 'GET',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
